module.exports = __webpack_public_path__ + "static/media/Call.8630b918.svg";